import { ArrowForwardIcon } from "@chakra-ui/icons";
import { Box, Card, Center, HStack, Link, Text } from "@chakra-ui/react";
import { Link as GatsbyLink } from "gatsby";
import React, { FC } from "react";
import { If, Then } from "react-if";
import { IImageFluidItem } from "../models/fluidImage";
import FluidImage from "./FluidImage";
import ProductTagNameTopRight from "./ProductTagNameTopRight";

interface IProps {
  item: {
    name: string;
    description: string;
    label: string;
    slug: string;
    isNew: boolean;
    image: IImageFluidItem;
  };
}

const ProductCardVerticalCenterItem: FC<IProps> = ({ item }) => {
  const { name, description, label, slug, isNew, image } = item;
  return (
    <Card h="full" p={4} border={"1px solid #F6F5F4"}>
      <Link
        as={GatsbyLink}
        to={`/${slug}`}
        display="flex"
        flexDirection="column"
        // justifyContent="space-between"
        h={"full"}
        textDecoration="none"
        _hover={{ textDecoration: "none" }}
      >
        <If condition={isNew}>
          <Then>
            <ProductTagNameTopRight nameOnTag="New" />
          </Then>
        </If>

        <Center bg="white" maxW="100%">
          <Box minH={20} borderRadius="md" overflow="hidden">
            <FluidImage imageItem={image} />
          </Box>
        </Center>

        <Text h={"3rem"} textStyle="h6" mt={3} mb={2} noOfLines={2}>
          {name}
        </Text>
        <Text
          textStyle="hind_m"
          mb={4}
          noOfLines={3}
          h={"4.5rem"}
          overflow="hidden"
        >
          {description}
        </Text>
        <HStack>
          <Text fontSize={"m"} color={"primary"} fontWeight={700}>
            {label || "View Product"}
          </Text>
          <ArrowForwardIcon color={"primary"} boxSize={5} />
        </HStack>
      </Link>
    </Card>
  );
};

export default ProductCardVerticalCenterItem;
